import { useAtom, useAtomValue } from 'jotai';
import { SegmentButton } from '../components';
import { currentSegmentAtom, isTrialModeAtom, moduleAtom } from '../data';
import { InfoIcon } from '../icons';

type Props = {
    segment1: string;
    segment2: string;
};
export function SegmentBar({ segment1, segment2 }: Props) {
    const [currentSegment, setCurrentSegment] = useAtom(currentSegmentAtom);
    const isTrialMode = useAtomValue(isTrialModeAtom);
    const module = useAtomValue(moduleAtom);
    const segment2OpenedAt = new Date(module.Segment2OpenedAt);
    const segment2OpenedAtFormatted = new Intl.DateTimeFormat('da-DK', {
        day: 'numeric',
        month: 'long',
    }).format(segment2OpenedAt);
    const isSegmentTwoLocked = segment2OpenedAt > new Date();

    return (
        <>
            <div
                className="hide-scrollbar sticky z-1 mx-[-20px] flex snap-x snap-mandatory overflow-x-scroll whitespace-nowrap bg-white px-20 py-30"
                style={{ top: 'calc(env(safe-area-inset-top) + 48px)' }}
            >
                <SegmentButton
                    segment={1}
                    name={segment1}
                    currentSegment={currentSegment}
                    onChangeCurrentSegment={setCurrentSegment}
                    className="mr-20 flex-1 basis-1/2"
                />
                <SegmentButton
                    segment={2}
                    name={segment2}
                    currentSegment={currentSegment}
                    onChangeCurrentSegment={setCurrentSegment}
                    showLockIcon={isTrialMode || isSegmentTwoLocked}
                    className="flex-1 basis-1/2"
                />
            </div>
            {isSegmentTwoLocked && currentSegment === 2 && (
                <div className="mb-30 flex flex-row rounded-[20px] bg-light-grey p-20 text-body-headline text-dark-red">
                    <InfoIcon className="mr-10 self-center" />
                    <div>
                        Giv dig selv tid til at øve dig på del 1. Del 2 åbner{' '}
                        {segment2OpenedAtFormatted}.
                    </div>
                </div>
            )}
        </>
    );
}
